/*
This component will NOT update if the state of the language is changed in LanguageService.
It is assumed that there will only be one of these widgets per page and as such
a page load will force the widget to use the currently selected language as the
default.
*/

import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { COMMON_IMPORTS } from '../../global-misc/common-imports';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { LanguageService } from '../../global-services/language.service';

interface LanguageOption {
    code: string,
    name: string
}

@Component({
    selector: 'app-global-lang-chooser',
    imports: [
        ...COMMON_IMPORTS,
        DropdownModule,
        FormsModule
    ],
    templateUrl: './global-lang-chooser.component.html',
    styleUrls: ['./global-lang-chooser.component.css']
})
export class GlobalLangChooserComponent {
    public languages = [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'French' },
    ];

    public selectedLanguage: LanguageOption;
    @Input() showGlobeIcon: boolean = true;

    constructor( private languageService: LanguageService) {
        this.selectedLanguage = this.getLanguageOptionFromLanguageCode(
            languageService.getLanguage() 
        );
    }

    private getLanguageOptionFromLanguageCode(languageCode: string): LanguageOption {
        const option: LanguageOption | undefined = this.languages.find(
            l => l.code === languageCode
        );
        if (!option) return { code: "N/A", name: "undefined" };
        return option;
    }

    public onChanged(language: LanguageOption) {
        this.languageService.setLanguage(language.code);
        this.selectedLanguage = language;
    }
}